export const setFormFieldValue = (formElements, fieldName, value) => {
    if (formElements[fieldName])
        formElements[fieldName].value = value;
}

export const setFormFieldsValues = (formElements, values) => {
    for (const [key, value] of Object.entries(values)) {
        setFormFieldValue(formElements, key, value);
    }
}